import { render, staticRenderFns } from "./distributionList.vue?vue&type=template&id=6e2136d4&"
import script from "./distributionList.vue?vue&type=script&lang=js&"
export * from "./distributionList.vue?vue&type=script&lang=js&"
import style0 from "./distributionList.vue?vue&type=style&index=0&id=6e2136d4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports